module.exports = __webpack_public_path__ + "img/btn_menu_uncertified.ddd5f3b2.png";